import React from 'react';
import { Icon } from './Icon.js';
export const IconLabel2Check2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3 5L3 19L15.5 19L22.5 12L15.5 5L3 5Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M7 12.5L9 14.5L14 9.5", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconLabel2Check2.js.map